import axios from "axios";
import useAuthStore from "../store/authStore.ts";

const VMS_BASE_URL = import.meta.env.VITE_VMS_BASE_URL;

const initialiseAxios = () => {
  return axios.create({
      baseURL: VMS_BASE_URL,
  });
}

const axiosInstance = initialiseAxios();


axiosInstance.interceptors.request.use(
    (config) => {
        const { token } = useAuthStore.getState();

        if (!token && config.url !== "/login_check") {
            return Promise.reject(new axios.Cancel("Requête annulée : Token non initialisé"));
        }
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const newAccessToken = await useAuthStore.getState().refreshAccessToken();

            if (newAccessToken) {
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return axiosInstance(originalRequest);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;


